import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { AngularFireDatabase } from 'angularfire2/database';

/**
 * Generated class for the SettingsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-settings',
  templateUrl: 'settings.html',
})
export class SettingsPage {
  uid: string;
  items: any = [];
  item: any;
  user: any;
  UserObj: any;
  path: string;
  loading: boolean = true;
  isEdit: boolean = true;
  btnName: string = 'Edit';
  btnColor: string = 'primary';
  loadedOnce: boolean = false;
  constructor(public navCtrl: NavController, public navParams: NavParams, public af: AngularFireDatabase) {
    this.user = JSON.parse(localStorage.getItem('UserId'));
    this.UserObj = JSON.parse(localStorage.getItem('UserObj'));
    this.path = 'restaurants/-1/servers/';
    this.af.object('users/' + this.user.uid).valueChanges().subscribe((res) => {
      this.item = res;
      if (!this.loadedOnce) {
        this.items.push(this.item);
        this.loadedOnce = true;
      }
      this.loading = false;
      console.log(res);
    });
    //  this.UserObj.$key = this.user.uid;

    this.uid = this.user.uid;
    console.log(this.user);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SettingsPage');
  }

  updatedList($event) {
    console.log($event);
    this.item.URL = $event;
    this.save();
  }

  save() {
    this.af.object('users/' + this.uid).update(this.item);
  }

  onEdit() {
    if (this.isEdit) {
      this.isEdit = false;
      this.btnName = 'Save';
      this.btnColor = 'secondary';
    }
    else {
      this.isEdit = true;
      this.btnName = 'Edit';
      this.btnColor = 'primary';
      this.save();
    }
  };

  setOnline(item) {

    let serverAvilPath = 'users/' + this.uid + '/isAvailable';
    //let key = item.key;
    if (item.isAvailable) {
      item.isAvailable = false;
      this.af.object(serverAvilPath).set(item.isAvailable);
    }
    else {
      item.isAvailable = true;
      this.af.object(serverAvilPath).set(item.isAvailable);
    }
  }

  turnOfforOn(item) {
    item.isAvailable = !item.isAvailable;
    this.af.list(this.path).update(item.key, item);
  }

}



// WEBPACK FOOTER //
// ./src/pages/settings/settings.ts